// src/layouts/AuthLayout.js
import React from 'react';

const AuthLayout = ({ children }) => {
  return (
    // <div className="d-flex align-items-center justify-content-center vh-100 auth-layout">
    <div className="auth-layout">
      <div className="">
        {children}
      </div>
    </div>
  );
};

export default AuthLayout;
